<template>
  <b-card no-body style="border-color: #80104b;">
    <div style="background-color: #80104b; color: white;" class="card-smallHeader card-header-action" v-b-toggle.collapse-completude-document>
                  <span><b>Complétude du dossier</b></span>
      <div class="card-header-actions">
              <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
        <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
      </div>
    </div>
    <b-collapse id="collapse-completude-document" class="m-3 pl-1 pr-1" v-model="showCompletudeDossier" :class="showCompletudeDossier ? null : 'collapsed'">
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">1</b-badge> <b>Identification du/des bénéficiaire(s)</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-group>
                <template slot="label"><b>Situation familiale :</b></template>
                <b-form-radio-group
                  id="radio-group-2-1"
                  v-model="myData.situation_familiale_id"
                  name="radio-situation-familliale"
                  :disabled="isDisabled('situation_familiale_id')"
                >
                  <b-form-radio v-for="situation of allSituationFamiliale" :key="situation.id" :value="situation.id">{{situation.libelle}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>Désignation de bénéficiaires :</b></template>
                <b-form-radio-group
                  id="radio-group-2-2"
                  v-model="myData.type_db"
                  name="radio-type_db"
                  :disabled="isDisabled('type_db')"
                  stacked
                >
                  <b-form-radio value="clause_type">Clause Type</b-form-radio>
                  <b-form-radio class="d-inline-block" value="autre">Autre : </b-form-radio><b-form-input class="d-inline-block ml-2 w-auto" type="text" v-model="myData.type_db_autre" :disabled="isDisabled('motif_resiliation')"></b-form-input>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>Cause du décès :</b></template>
                <b-form-radio-group
                  id="radio-group-2-3"
                  v-model="myData.cause_deces"
                  name="radio-cause_deces"
                  :disabled="isDisabled('cause_deces')"
                >
                  <b-form-radio value="mort_naturelle">Mort naturelle</b-form-radio>
                  <b-form-radio value="accident">Accident</b-form-radio>
                  <b-form-radio value="suicide">Suicide</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <template slot="label"><b>Si suicide, l'assuré remplit-il les conditions d'ancienneté prévues ?</b></template>
                <b-form-radio-group
                  id="radio-group-2-4"
                  v-model="myData.has_condition_ancienete"
                  name="radio-has_condition_ancienete"
                  :disabled="isDisabled('has_condition_ancienete')"
                >
                  <b-form-radio value="true">Oui</b-form-radio>
                  <b-form-radio value="false">Non</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">2</b-badge> <b>Garanties souscrites</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-checkbox v-model="myData.has_capital_deces" name="checkbox-has_capital_deces" value="true" unchecked-value="false" :disabled="isDisabled('has_capital_deces')">
                Capital décès
              </b-form-checkbox>
              <b-form-checkbox class="ml-4" v-model="myData.has_majoration_accident" name="checkbox-has_majoration_accident" value="true" unchecked-value="false" :disabled="isDisabled('has_majoration_accident')">
                Majoration accident
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_capital_optionnel" name="checkbox-has_capital_optionnel" value="true" unchecked-value="false" :disabled="isDisabled('has_capital_optionnel')">
                Capital optionnel
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_majorations_familiales" name="checkbox-has_majorations_familiales" value="true" unchecked-value="false" :disabled="isDisabled('has_majorations_familiales')">
                Majorations familiales
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_rente_education_ocirp" name="checkbox-has_rente_education_ocirp" value="true" unchecked-value="false" :disabled="isDisabled('has_rente_education_ocirp')">
                Rente éducation OCIRP
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_rente_education_chorum" name="checkbox-has_rente_education_chorum" value="true" unchecked-value="false" :disabled="isDisabled('has_rente_education_chorum')">
                Rente éducation Chorum
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_rente_conjoint_ocirp" name="checkbox-has_rente_conjoint_ocirp" value="true" unchecked-value="false" :disabled="isDisabled('has_rente_conjoint_ocirp')">
                Rente conjoint (viagère / temporaire) OCIRP
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_rente_conjoint_chorum" name="checkbox-has_rente_conjoint_chorum" value="true" unchecked-value="false" :disabled="isDisabled('has_rente_conjoint_chorum')">
                Rente conjoint (viagère / temporaire) Chorum
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_rente_substitutive_conjoint" name="checkbox-has_rente_substitutive_conjoint" value="true" unchecked-value="false" :disabled="isDisabled('has_rente_substitutive_conjoint')">
                Rente substitutive de conjoint (OCIRP)
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_frais_obseques" name="checkbox-has_frais_obseques" value="true" unchecked-value="false" :disabled="isDisabled('has_frais_obseques')">
                Frais d'obsèques
              </b-form-checkbox><br>
              <b-form-checkbox v-model="myData.has_capital_deces_famille" name="checkbox-has_capital_deces_famille" value="true" unchecked-value="false" :disabled="isDisabled('has_capital_deces_famille')">
                Capital décès famille
              </b-form-checkbox><br>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">3</b-badge> <b>Concernant l'assuré</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-group
                label-for="date_document_declaration_deces"
                :label-cols="4"
                label-size="sm"
                :horizontal="true">
                <template slot="label"><b>Déclaration de décès</b></template>
                <b-form-input size="sm" id="date_document_declaration_deces" :disabled="isDisabled('date_document_declaration_deces')" v-model="myData.date_document_declaration_deces" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_acte_deces"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Acte de décès</b></template>
                <b-form-input size="sm" id="date_document_acte_deces" :disabled="isDisabled('date_document_acte_deces')" v-model="myData.date_document_acte_deces" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_certificat_post_mortem"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Certificat médical post-mortem</b></template>
                <b-form-input size="sm" id="date_document_certificat_post_mortem" :disabled="isDisabled('date_document_certificat_post_mortem')" v-model="myData.date_document_certificat_post_mortem" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_pv_gendarmerie"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>PV de la gendarmerie</b></template>
                <b-form-input size="sm" id="date_document_pv_gendarmerie" :disabled="isDisabled('date_document_pv_gendarmerie')" v-model="myData.date_document_pv_gendarmerie" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_dernier_avis_imposition"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Dernier avis d'imposition</b></template>
                <b-form-input size="sm" id="date_document_dernier_avis_imposition" :disabled="isDisabled('date_document_dernier_avis_imposition')" v-model="myData.date_document_dernier_avis_imposition" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_attestation_periode_activite"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Attestation période activité</b></template>
                <b-form-input size="sm" id="date_document_attestation_periode_activite" :disabled="isDisabled('date_document_attestation_periode_activite')" v-model="myData.date_document_attestation_periode_activite" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_photocopie_12_bs"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Photocopie 12 BS</b></template>
                <b-form-input size="sm" id="date_document_photocopie_12_bs" :disabled="isDisabled('date_document_photocopie_12_bs')" v-model="myData.date_document_photocopie_12_bs" type="date">
                </b-form-input>
              </b-form-group>
              <div class="pl-4">
                <span class="mr-2">période du</span><b-form-input size="sm" id="periode_du" class="d-inline-block w-auto mr-2" type="date" v-model="myData.date_bs_periode_du" :disabled="isDisabled('date_bs_periode_du')"></b-form-input><span class="mr-2"> au </span><b-form-input id="periode_au" size="sm" class="d-inline-block w-auto" type="date" v-model="myData.date_bs_periode_au" :disabled="isDisabled('date_bs_periode_au')"></b-form-input>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">4</b-badge> <b>Concernant la situation familiale</b></span>
            </div>
            <b-card-text class="p-1">
              <b-form-group
                label-size="sm"
                label-for="date_document_livret_famille"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Livret de famille</b></template>
                <b-form-input size="sm" id="date_document_livret_famille" :disabled="isDisabled('date_document_livret_famille')" v-model="myData.date_document_livret_famille" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_acte_notoriete_mention_pacs"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Acte de notoriété mention PACS</b></template>
                <b-form-input size="sm" id="date_document_acte_notoriete_mention_pacs" :disabled="isDisabled('date_document_acte_notoriete_mention_pacs')" v-model="myData.date_document_acte_notoriete_mention_pacs" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_extrait_acte_naissance"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Extrait acte de naissance (assuré)</b></template>
                <b-form-input size="sm" id="date_document_extrait_acte_naissance" :disabled="isDisabled('date_document_extrait_acte_naissance')" v-model="myData.date_document_extrait_acte_naissance" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_attestation_tribunal_instance_pacs"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Attestation Tribunal Instance PACS</b></template>
                <b-form-input size="sm" id="date_document_attestation_tribunal_instance_pacs" :disabled="isDisabled('date_document_attestation_tribunal_instance_pacs')" v-model="myData.date_document_attestation_tribunal_instance_pacs" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_attestation_pacs_non_denonce"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Attestation PACS non dénoncé</b></template>
                <b-form-input size="sm" id="date_document_attestation_pacs_non_denonce" :disabled="isDisabled('date_document_attestation_pacs_non_denonce')" v-model="myData.date_document_attestation_pacs_non_denonce" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_attestation_concubinage"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Attestation de concubinage</b></template>
                <b-form-input size="sm" id="date_document_attestation_concubinage" :disabled="isDisabled('date_document_attestation_concubinage')" v-model="myData.date_document_attestation_concubinage" type="date">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label-size="sm"
                label-for="date_document_justificatif_domicile_commun"
                :label-cols="4"
                :horizontal="true">
                <template slot="label"><b>Justificatif de domicile commun</b></template>
                <b-form-input size="sm" id="date_document_justificatif_domicile_commun" :disabled="isDisabled('date_document_justificatif_domicile_commun')" v-model="myData.date_document_justificatif_domicile_commun" type="date">
                </b-form-input>
              </b-form-group>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">5</b-badge> <b>Concernant les bénéficiaires du capital</b></span>
            </div>
            <b-card-text class="p-1">
              <b-row class="mb-2">
                <b-col sm="2"><b>Nom</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="beneficiaire.id" >
                  <b>{{ beneficiaire.prenom+' '+beneficiaire.nom }}</b><br>
                  <span class="smaller" v-html="getCapitalDecesLibelle(beneficiaire)"></span><br>
                  <span class="smaller" v-html="getAllocationsLibelle(beneficiaire)"></span>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>RIB</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentCapitalRib" :key="'rib'+data.id" >
                  <b-form-input size="sm" :id="'capitalRib_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.capitalRib[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Justificatif de domicile</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentCapitalJustificatifDomicile" :key="'jd'+data.id" >
                  <b-form-input size="sm" :id="'capitalJustificatifDomicile_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.capitalJustificatifDomicile[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Pièce d'identité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentCapitalPI" :key="'pi'+data.id" >
                  <b-form-input size="sm" :id="'capitalPI_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.capitalPI[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Jugement de tutelle</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentCapitalJugementTutelle" :key="'jt'+data.id" >
                  <b-form-input size="sm" :id="'capitalJugementTutelle_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.capitalJugementTutelle[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Facture acquittée des frais d'obsèques</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentCapitalFactureFraisObseque" :key="'jt'+data.id" >
                  <b-form-input size="sm" :id="'capitalFactureFraisObseque_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.capitalFactureFraisObseque[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b class="text-danger">Date connaissance adresse bénéficiaire</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentCapitalConnaisanceAdresse" :key="'ca'+data.id" >
                  <b-form-input size="sm" :id="'capitalConnaisanceAdresse_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.capitalConnaisanceAdresse[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b-form-input size="sm" :id="'champ_capital_libre1'" :disabled="isDisabled('champ_capital_libre1')" v-model="myData.libelleCapitalChampLibre1" type="text"></b-form-input></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentCapitalChampLibre1" :key="'jt'+data.id" >
                  <b-form-input size="sm" :id="'capitalChampLibre1_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.capitalChampLibre1[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b-form-input size="sm" :id="'champ_capital_libre2'" :disabled="isDisabled('champ_capital_libre2')" v-model="myData.libelleCapitalChampLibre2" type="text"></b-form-input></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentCapitalChampLibre2" :key="'jt'+data.id" >
                  <b-form-input size="sm" :id="'capitalChampLibre2_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.capitalChampLibre2[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader">
              <span><b-badge variant="warning" class="mr-2">6</b-badge> <b>Concernant les bénéficiaires de rente éducation et rente conjoint</b></span>
            </div>
            <b-card-text class="p-1">
              <b-row class="mb-2">
                <b-col sm="2"><b>Nom</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="beneficiaire in dossier.deces_beneficiaire" :key="beneficiaire.id" >
                  <b>{{ beneficiaire.prenom+' '+beneficiaire.nom }}</b><br>
                  <span class="smaller" v-html="getRentesLibelle(beneficiaire)"></span>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>RIB</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesRib" :key="'ribr'+data.id" >
                  <b-form-input size="sm" :id="'rentesRib_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesRib[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Justificatif de domicile</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesJustificatifDomicile" :key="'jdr'+data.id" >
                  <b-form-input size="sm" :id="'rentesJustificatifDomicile_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesJustificatifDomicile[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Extrait acte de naissance</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesActeNaissance" :key="'an'+data.id" >
                  <b-form-input size="sm" :id="'rentesActeNaissance_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesActeNaissance[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Pièce d'identité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesPI" :key="'pir'+data.id" >
                  <b-form-input size="sm" :id="'rentesPI_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesPI[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Certificat de scolarité</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesCertificatScolarite" :key="'cs'+data.id" >
                  <b-form-input size="sm" :id="'rentesCertificatScolarite_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesCertificatScolarite[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Attestation SS étudiant</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesAttestationSsEtudiant" :key="'sse'+data.id" >
                  <b-form-input size="sm" :id="'rentesAttestationSsEtudiant_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesAttestationSsEtudiant[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Contrat d'apprentissage</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesContratApprentissage" :key="'cap'+data.id" >
                  <b-form-input size="sm" :id="'rentesContratApprentissage_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesContratApprentissage[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Jugement de tutelle</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesJugementTutelle" :key="'jtr'+data.id" >
                  <b-form-input size="sm" :id="'rentesJugementTutelle_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesJugementTutelle[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Attestation inscription Pôle Emploi</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesAttestationPoleEmploi" :key="'pe'+data.id" >
                  <b-form-input size="sm" :id="'rentesAttestationPoleEmploi_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesAttestationPoleEmploi[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Carte d'invalidité / Attest. MDPH</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesCarteInvaliditeMdph" :key="'ci'+data.id" >
                  <b-form-input size="sm" :id="'rentesCarteInvaliditeMdph_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesCarteInvaliditeMdph[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b>Attest. Rente substitutive de conjoint</b></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesAttestationRenteSubstitutive" :key="'rsc'+data.id" >
                  <b-form-input size="sm" :id="'rentesAttestationRenteSubstitutive_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesAttestationRenteSubstitutive[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b-form-input size="sm" :id="'champ_rente_libre1'" :disabled="isDisabled('champ_rente_libre1')" v-model="myData.libelleRenteChampLibre1" type="text"></b-form-input></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesChampLibre1" :key="'jt'+data.id" >
                  <b-form-input size="sm" :id="'rentesChampLibre1_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesChampLibre1[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2"><b-form-input size="sm" :id="'champ_rente_libre2'" :disabled="isDisabled('champ_capital_libre2')" v-model="myData.libelleRenteChampLibre2" type="text"></b-form-input></b-col>
                <b-col :sm="Math.floor(10/dossier.deces_beneficiaire.length)" v-for="data in documentRentesChampLibre2" :key="'jt'+data.id" >
                  <b-form-input size="sm" :id="'rentesChampLibre2_'+data.id" :disabled="isDisabled('capital_rib')" v-model="myData.rentesChampLibre2[data.id]" type="date"></b-form-input>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-button class="float-right mt-2 mb-1 mr-1" variant="primary" @click="save()"><i class="fa fa-save"></i>
        Enregistrer
      </b-button>
    </b-collapse>
  </b-card>
</template>

<script>
  import { isEmpty } from '@/utils/fileHelper';
  import {downloadFile, guardedFile} from "@/utils/fileHelper"

  export default {
    name: "CompletudeDossier",
    props: [
      'dossier',
      'traitements',
      'allFamillesProduits'
    ],
    data() {
      return {
        isEmpty,
        allSituationFamiliale: [],
        documentCapitalRib: [],
        documentCapitalJustificatifDomicile: [],
        documentCapitalPI: [],
        documentCapitalJugementTutelle: [],
        documentCapitalConnaisanceAdresse: [],
        documentCapitalFactureFraisObseque: [],
        documentCapitalChampLibre1: [],
        documentCapitalChampLibre2: [],
        documentRentesRib: [],
        documentRentesJustificatifDomicile: [],
        documentRentesActeNaissance: [],
        documentRentesPI: [],
        documentRentesCertificatScolarite: [],
        documentRentesAttestationSsEtudiant: [],
        documentRentesContratApprentissage: [],
        documentRentesJugementTutelle: [],
        documentRentesAttestationPoleEmploi: [],
        documentRentesCarteInvaliditeMdph: [],
        documentRentesAttestationRenteSubstitutive: [],
        documentRentesChampLibre1: [],
        documentRentesChampLibre2: [],
        myData: {
          situation_familiale_id: '',
          type_db: '',
          type_db_autre: '',
          cause_deces: '',
          has_condition_ancienete: '',
          has_capital_deces: '',
          has_majoration_accident: '',
          has_capital_optionnel: '',
          has_majorations_familiales: '',
          has_rente_education_ocirp: '',
          has_rente_education_chorum: '',
          has_rente_conjoint_ocirp: '',
          has_rente_conjoint_chorum: '',
          has_rente_substitutive_conjoint: '',
          has_frais_obseques: '',
          has_capital_deces_famille: '',
          date_document_declaration_deces: '',
          date_document_acte_deces: '',
          date_document_certificat_post_mortem: '',
          date_document_pv_gendarmerie: '',
          date_document_dernier_avis_imposition: '',
          date_document_attestation_periode_activite: '',
          date_document_photocopie_12_bs: '',
          date_bs_periode_du: '',
          date_bs_periode_au: '',
          date_document_livret_famille: '',
          date_document_acte_notoriete_mention_pacs: '',
          date_document_extrait_acte_naissance: '',
          date_document_attestation_tribunal_instance_pacs: '',
          date_document_attestation_pacs_non_denonce: '',
          date_document_attestation_concubinage: '',
          date_document_justificatif_domicile_commun: '',
          capitalRib: {},
          capitalJustificatifDomicile: {},
          capitalPI: {},
          capitalJugementTutelle: {},
          capitalConnaisanceAdresse: {},
          capitalFactureFraisObseque: {},
          capitalChampLibre1: {},
          capitalChampLibre2: {},

          rentesRib: {},
          rentesJustificatifDomicile: {},
          rentesActeNaissance: {},
          rentesPI: {},
          rentesCertificatScolarite: {},
          rentesAttestationSsEtudiant: {},
          rentesContratApprentissage: {},
          rentesJugementTutelle: {},
          rentesAttestationPoleEmploi: {},
          rentesCarteInvaliditeMdph: {},
          rentesAttestationRenteSubstitutive: {},
          rentesChampLibre1: {},
          rentesChampLibre2: {},
          libelleCapitalChampLibre1: '',
          libelleCapitalChampLibre2: '',
          libelleRenteChampLibre1: '',
          libelleRenteChampLibre2: '',
        },
        showCompletudeDossier: false,
        capitalOptions: [
          {code: 'has_capital', name: 'Capital'},
          // {code: 'has_capital_sup_75', name: 'Capital > 75k€ Mutex'},
          {code: 'has_capital_sup_150', name: 'Capital > 150k€ validation direction'},
          {code: 'has_capital_orphelin', name: 'Capital orphelin'},
          {code: 'has_maloration_personne_a_charge', name: 'Majoration personne à charge'},
          {code: 'has_maloration_accident', name: 'Majoration Accident'},
        ],
        rentesOptions: [
          {code: 'has_rente_conjoint', name: 'Rente Conjoint/Viagère'},
          {code: 'has_rente_education', name: 'Rente Education'},
          {code: 'has_rente_temporaire', name: 'Rente temporaire'},
          {code: 'has_rente_ocirp', name: 'Rente OCIRP gérée par Mutex'},
          {code: 'has_rente_viagere_orphelin', name: 'Rente viagère orphelin'},
          {code: 'has_rente_viagere_handicap', name: 'Rente viagère handicap'},
        ],
        allocationsOptions: [
          {code: 'has_allocation_obseque', name: 'Allocations Obsèques'},
        ],
      }
    },
    watch: {
      myData: {
        handler: _.debounce(function (value) {
          this.$event.emit('editDossier', 'CompletudeDossier', value);
          this.calculInputClass();
        }, 1000),
        deep: true,
      },
      dossier() {
        this.setDocumentsBeneficiaireCapital();
        this.setDocumentsBeneficiaireRentes();
      },
    },
    computed: {
    },
    async mounted() {
      // let inputs = this.inputDate;

      // console.log(this.allFamillesProduits)
      this.$event.on('pjOk', data => {

        let pj = this.dossier.pieces_jointes.find(pj => pj.id === parseInt(data.pjId,10));
        for (let typeId of data.typesId) {
          let selectedType = data.allTypes.find(type => type.id === typeId);
          // console.log('dans envent pjOk selectedType',selectedType)
          if (selectedType.libelle_technique === 'rib_dc') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.capitalRib) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.capitalRib[beneficiaireId])) {
                  // this.myData.capitalRib[beneficiaireId] = pj.date_reception;
                  this.$set(this.myData.capitalRib, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.capitalRib[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.capitalRib, beneficiaireId, null);
                }
              }
              for (let beneficiaireId in this.myData.rentesRib) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesRib[beneficiaireId])) {
                  // this.myData.rentesRib[beneficiaireId] = pj.date_reception;
                  this.$set(this.myData.rentesRib, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesRib[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesRib, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'justif_domicile_beneficiare') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.capitalJustificatifDomicile) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.capitalJustificatifDomicile[beneficiaireId])) {
                  // this.myData.capitalJustificatifDomicile[beneficiaireId] = pj.date_reception;
                  this.$set(this.myData.capitalJustificatifDomicile, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.capitalJustificatifDomicile[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.capitalJustificatifDomicile, beneficiaireId, null);
                }
              }
              for (let beneficiaireId in this.myData.rentesJustificatifDomicile) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesJustificatifDomicile[beneficiaireId])) {
                  // this.myData.rentesJustificatifDomicile[beneficiaireId] = pj.date_reception;
                  this.$set(this.myData.rentesJustificatifDomicile, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesJustificatifDomicile[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesJustificatifDomicile, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'photocopie_piece_identite' || selectedType.libelle_technique === 'cni_dc_33') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.capitalPI) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.capitalPI[beneficiaireId])) {
                  // this.myData.capitalPI[beneficiaireId] = pj.date_reception;
                  this.$set(this.myData.capitalPI, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.capitalPI[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.capitalPI, beneficiaireId, null);
                }
              }
              for (let beneficiaireId in this.myData.rentesPI) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesPI[beneficiaireId])) {
                  // this.myData.rentesPI[beneficiaireId] = pj.date_reception;
                  this.$set(this.myData.rentesPI, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesPI[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesPI, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'jugement_tutelle') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.capitalJugementTutelle) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.capitalJugementTutelle[beneficiaireId])) {
                  // this.myData.capitalJugementTutelle[beneficiaireId] = pj.date_reception;
                  this.$set(this.myData.capitalJugementTutelle, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.capitalJugementTutelle[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.capitalJugementTutelle, beneficiaireId, null);
                }
              }
              for (let beneficiaireId in this.myData.rentesJugementTutelle) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesJugementTutelle[beneficiaireId])) {
                  // this.myData.rentesJugementTutelle[beneficiaireId] = pj.date_reception;
                  this.$set(this.myData.rentesJugementTutelle, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesJugementTutelle[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesJugementTutelle, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'extrait_acte_naissance') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.rentesActeNaissance) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesActeNaissance[beneficiaireId])) {
                  this.$set(this.myData.rentesActeNaissance, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesActeNaissance[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesActeNaissance, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'certificat_scolarite') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.rentesCertificatScolarite) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesCertificatScolarite[beneficiaireId])) {
                  this.$set(this.myData.rentesCertificatScolarite, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesCertificatScolarite[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesCertificatScolarite, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'attestation_ss_etudiant') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.rentesAttestationSsEtudiant) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesAttestationSsEtudiant[beneficiaireId])) {
                  this.$set(this.myData.rentesAttestationSsEtudiant, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesAttestationSsEtudiant[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesAttestationSsEtudiant, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'contrat_apprentissage') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.rentesContratApprentissage) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesContratApprentissage[beneficiaireId])) {
                  this.$set(this.myData.rentesContratApprentissage, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesContratApprentissage[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesContratApprentissage, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'attestation_inscription_pole_emploi') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.rentesAttestationPoleEmploi) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesAttestationPoleEmploi[beneficiaireId])) {
                  this.$set(this.myData.rentesAttestationPoleEmploi, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesAttestationPoleEmploi[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesAttestationPoleEmploi, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'carte_invalidite') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.rentesCarteInvaliditeMdph) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesCarteInvaliditeMdph[beneficiaireId])) {
                  this.$set(this.myData.rentesCarteInvaliditeMdph, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesCarteInvaliditeMdph[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesCarteInvaliditeMdph, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'attestation_mdph') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.rentesCarteInvaliditeMdph) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesCarteInvaliditeMdph[beneficiaireId])) {
                  this.$set(this.myData.rentesCarteInvaliditeMdph, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesCarteInvaliditeMdph[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesCarteInvaliditeMdph, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'attestation_rente_substitutive_conjoint') {
            for (let selectedBeneficiaireId of data.beneficiairesIds) {
              for (let beneficiaireId in this.myData.rentesAttestationRenteSubstitutive) {
                if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && data.isPjOk && isEmpty(this.myData.rentesAttestationRenteSubstitutive[beneficiaireId])) {
                  this.$set(this.myData.rentesAttestationRenteSubstitutive, beneficiaireId, pj.date_reception);
                } else if (parseInt(beneficiaireId,10) === parseInt(selectedBeneficiaireId,10) && !data.isPjOk && this.myData.rentesAttestationRenteSubstitutive[beneficiaireId] === pj.date_reception) {
                  this.$set(this.myData.rentesAttestationRenteSubstitutive, beneficiaireId, null);
                }
              }
            }
          } else if (selectedType.libelle_technique === 'declaration_deces') {
            if (data.isPjOk && isEmpty(this.myData.date_document_declaration_deces)) {
              this.myData.date_document_declaration_deces = pj.date_reception;
              // this.$set(this.myData, date_document_declaration_deces, pj.date_reception);
            } else if (!data.isPjOk && this.myData.date_document_declaration_deces === pj.date_reception) {
              this.myData.date_document_declaration_deces = null;
              // this.$set(this.myData, date_document_declaration_deces, null);
            }
          } else if (selectedType.libelle_technique === 'acte_deces_original') {
            if (data.isPjOk && isEmpty(this.myData.date_document_acte_deces)) {
              this.myData.date_document_acte_deces = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_acte_deces === pj.date_reception) {
              this.myData.date_document_acte_deces = null;
            }
          } else if (selectedType.libelle_technique === 'certificat_medical_postmortem') {
            if (data.isPjOk && isEmpty(this.myData.date_document_certificat_post_mortem)) {
              this.myData.date_document_certificat_post_mortem = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_certificat_post_mortem === pj.date_reception) {
              this.myData.date_document_certificat_post_mortem = null;
            }
          } else if (selectedType.libelle_technique === 'proces_verbal') {
            if (data.isPjOk && isEmpty(this.myData.date_document_pv_gendarmerie)) {
              this.myData.date_document_pv_gendarmerie = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_pv_gendarmerie === pj.date_reception) {
              this.myData.date_document_pv_gendarmerie = null;
            }
          } else if (selectedType.libelle_technique === 'avis_imposition_dc') {
            if (data.isPjOk && isEmpty(this.myData.date_document_dernier_avis_imposition)) {
              this.myData.date_document_dernier_avis_imposition = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_dernier_avis_imposition === pj.date_reception) {
              this.myData.date_document_dernier_avis_imposition = null;
            }
          } else if (selectedType.libelle_technique === 'attestation_employeur') {
            if (data.isPjOk && isEmpty(this.myData.date_document_attestation_periode_activite)) {
              this.myData.date_document_attestation_periode_activite = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_attestation_periode_activite === pj.date_reception) {
              this.myData.date_document_attestation_periode_activite = null;
            }
          } else if (selectedType.libelle_technique === 'livret_famille_dc') {
            if (data.isPjOk && isEmpty(this.myData.date_document_livret_famille)) {
              this.myData.date_document_livret_famille = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_livret_famille === pj.date_reception) {
              this.myData.date_document_livret_famille = null;
            }
          } else if (selectedType.libelle_technique === 'acte_notoriete_mention_pacs') {
            if (data.isPjOk && isEmpty(this.myData.date_document_acte_notoriete_mention_pacs)) {
              this.myData.date_document_acte_notoriete_mention_pacs = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_acte_notoriete_mention_pacs === pj.date_reception) {
              this.myData.date_document_acte_notoriete_mention_pacs = null;
            }
          } else if (selectedType.libelle_technique === 'extrait_acte_naissance_assure') {
            if (data.isPjOk && isEmpty(this.myData.date_document_extrait_acte_naissance)) {
              this.myData.date_document_extrait_acte_naissance = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_extrait_acte_naissance === pj.date_reception) {
              this.myData.date_document_extrait_acte_naissance = null;
            }
          } else if (selectedType.libelle_technique === 'attestation_ti_pacs') {
            if (data.isPjOk && isEmpty(this.myData.date_document_attestation_tribunal_instance_pacs)) {
              this.myData.date_document_attestation_tribunal_instance_pacs = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_attestation_tribunal_instance_pacs === pj.date_reception) {
              this.myData.date_document_attestation_tribunal_instance_pacs = null;
            }
          } else if (selectedType.libelle_technique === 'attestation_pacs_denonce') {
            if (data.isPjOk && isEmpty(this.myData.date_document_attestation_pacs_non_denonce)) {
              this.myData.date_document_attestation_pacs_non_denonce = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_attestation_pacs_non_denonce === pj.date_reception) {
              this.myData.date_document_attestation_pacs_non_denonce = null;
            }
          } else if (selectedType.libelle_technique === 'attestation_concubinage') {
            if (data.isPjOk && isEmpty(this.myData.date_document_attestation_concubinage)) {
              this.myData.date_document_attestation_concubinage = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_attestation_concubinage === pj.date_reception) {
              this.myData.date_document_attestation_concubinage = null;
            }
          } else if (selectedType.libelle_technique === 'justif_domicile_commun') {
            if (data.isPjOk && isEmpty(this.myData.date_document_justificatif_domicile_commun)) {
              this.myData.date_document_justificatif_domicile_commun = pj.date_reception;
            } else if (!data.isPjOk && this.myData.date_document_justificatif_domicile_commun === pj.date_reception) {
              this.myData.date_document_justificatif_domicile_commun = null;
            }
          }

        }

      });
      this.setForm();
      this.setDocumentsBeneficiaireCapital();
      this.setDocumentsBeneficiaireRentes();
      await this.getAllSituationFamiliale();

      this.calculInputClass();
    },
    methods: {
      calculInputClass() {
        let inputs = document.querySelectorAll('#collapse-completude-document input[type="date"]')
        // console.log('inputs',inputs)
        for (let input of inputs) {
          if (!isEmpty(input.value)) {
            let inputAdd = document.getElementById(input.id);
            if (!isEmpty(inputAdd)) {
              inputAdd.classList.add("blue-date");
            }
          } else {
            let inputRemove = document.getElementById(input.id);
            if (!isEmpty(inputRemove)) {
              inputRemove.classList.remove("blue-date");
            }
          }
        }
      },
      setForm() {
        if (!isEmpty(this.dossier.fiche_deces)) {
          this.myData.situation_familiale_id = this.dossier.fiche_deces.situation_familiale_id;
          this.myData.cause_deces = this.dossier.fiche_deces.cause_deces;
          this.myData.type_db = this.dossier.fiche_deces.type_db;
          this.myData.type_db_autre = this.dossier.fiche_deces.type_db_autre;
          this.myData.has_condition_ancienete = this.dossier.fiche_deces.has_condition_ancienete === true ? 'true' : (this.dossier.fiche_deces.has_condition_ancienete === false ? 'false' : '');
          this.myData.has_capital_deces = this.dossier.fiche_deces.has_capital_deces === true ? 'true' : (this.dossier.fiche_deces.has_capital_deces === false ? 'false' : '');
          this.myData.has_majoration_accident = this.dossier.fiche_deces.has_majoration_accident === true ? 'true' : (this.dossier.fiche_deces.has_majoration_accident === false ? 'false' : '');
          this.myData.has_capital_optionnel = this.dossier.fiche_deces.has_capital_optionnel === true ? 'true' : (this.dossier.fiche_deces.has_capital_optionnel === false ? 'false' : '');
          this.myData.has_majorations_familiales = this.dossier.fiche_deces.has_majorations_familiales === true ? 'true' : (this.dossier.fiche_deces.has_majorations_familiales === false ? 'false' : '');
          this.myData.has_rente_education_ocirp = this.dossier.fiche_deces.has_rente_education_ocirp === true ? 'true' : (this.dossier.fiche_deces.has_rente_education_ocirp === false ? 'false' : '');
          this.myData.has_rente_education_chorum = this.dossier.fiche_deces.has_rente_education_chorum === true ? 'true' : (this.dossier.fiche_deces.has_rente_education_chorum === false ? 'false' : '');
          this.myData.has_rente_conjoint_ocirp = this.dossier.fiche_deces.has_rente_conjoint_ocirp === true ? 'true' : (this.dossier.fiche_deces.has_rente_conjoint_ocirp === false ? 'false' : '');
          this.myData.has_rente_conjoint_chorum = this.dossier.fiche_deces.has_rente_conjoint_chorum === true ? 'true' : (this.dossier.fiche_deces.has_rente_conjoint_chorum === false ? 'false' : '');
          this.myData.has_rente_substitutive_conjoint = this.dossier.fiche_deces.has_rente_substitutive_conjoint === true ? 'true' : (this.dossier.fiche_deces.has_rente_substitutive_conjoint === false ? 'false' : '');
          this.myData.has_frais_obseques = this.dossier.fiche_deces.has_frais_obseques === true ? 'true' : (this.dossier.fiche_deces.has_frais_obseques === false ? 'false' : '');
          this.myData.has_capital_deces_famille = this.dossier.fiche_deces.has_capital_deces_famille === true ? 'true' : (this.dossier.fiche_deces.has_capital_deces_famille === false ? 'false' : '');
          this.myData.date_document_declaration_deces = this.dossier.fiche_deces.date_document_declaration_deces;
          this.myData.date_document_acte_deces = this.dossier.fiche_deces.date_document_acte_deces;
          this.myData.date_document_certificat_post_mortem = this.dossier.fiche_deces.date_document_certificat_post_mortem;
          this.myData.date_document_pv_gendarmerie = this.dossier.fiche_deces.date_document_pv_gendarmerie;
          this.myData.date_document_dernier_avis_imposition = this.dossier.fiche_deces.date_document_dernier_avis_imposition;
          this.myData.date_document_attestation_periode_activite = this.dossier.fiche_deces.date_document_attestation_periode_activite;
          this.myData.date_document_photocopie_12_bs = this.dossier.fiche_deces.date_document_photocopie_12_bs;
          this.myData.date_bs_periode_du = this.dossier.fiche_deces.date_bs_periode_du;
          this.myData.date_bs_periode_au = this.dossier.fiche_deces.date_bs_periode_au;
          this.myData.date_document_livret_famille = this.dossier.fiche_deces.date_document_livret_famille;
          this.myData.date_document_acte_notoriete_mention_pacs = this.dossier.fiche_deces.date_document_acte_notoriete_mention_pacs;
          this.myData.date_document_extrait_acte_naissance = this.dossier.fiche_deces.date_document_extrait_acte_naissance;
          this.myData.date_document_attestation_tribunal_instance_pacs = this.dossier.fiche_deces.date_document_attestation_tribunal_instance_pacs;
          this.myData.date_document_attestation_pacs_non_denonce = this.dossier.fiche_deces.date_document_attestation_pacs_non_denonce;
          this.myData.date_document_attestation_concubinage = this.dossier.fiche_deces.date_document_attestation_concubinage;
          this.myData.date_document_justificatif_domicile_commun = this.dossier.fiche_deces.date_document_justificatif_domicile_commun;
        }
      },
      isDisabled(field) {
        return this.$parent.$parent.$parent.isDisabled(field);
      },
      getAllSituationFamiliale() {
        return new Promise((resolve, reject) => {
          let self = this;
          this.$axios
            .get(`/espaceGestion/situation-familiale/all`)
            .then(response => {
              // console.log('autocomplete data', response.data.data)
              this.allSituationFamiliale = response.data.situations_familiales;
              resolve();
            })
            .catch(function (error) {
              console.log(error);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue lors de la récupération de la liste des situations familiales, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
              reject(error)
            })
        })
      },
      setDocumentsBeneficiaireCapital() {
        // console.log('dans setDocumentsBeneficiaireCapital this.dossier.deces_beneficiaire : ',this.dossier.deces_beneficiaire)
        if (!isEmpty(this.dossier.deces_beneficiaire)) {
          this.clearDocumentsCapital();
          for (let beneficiaire of this.dossier.deces_beneficiaire) {
            // this.myData.capitalRib[beneficiaire.id] = beneficiaire.date_document_capital_rib;
            this.$set(this.myData.capitalRib, beneficiaire.id, beneficiaire.date_document_capital_rib);
            this.documentCapitalRib.push({id: beneficiaire.id, date: beneficiaire.date_document_capital_rib});

            this.$set(this.myData.capitalJustificatifDomicile, beneficiaire.id, beneficiaire.date_document_capital_justificatif_domicile);
            this.documentCapitalJustificatifDomicile.push({id: beneficiaire.id, date: beneficiaire.date_document_capital_justificatif_domicile});

            this.myData.capitalPI[beneficiaire.id] = beneficiaire.date_document_capital_piece_identite;
            this.documentCapitalPI.push({id: beneficiaire.id, date: beneficiaire.date_document_capital_piece_identite});

            this.myData.capitalJugementTutelle[beneficiaire.id] = beneficiaire.date_document_capital_jugement_tutelle;
            this.documentCapitalJugementTutelle.push({id: beneficiaire.id, date: beneficiaire.date_document_capital_jugement_tutelle});

            this.myData.capitalConnaisanceAdresse[beneficiaire.id] = beneficiaire.date_document_capital_connaissance_adresse_beneficiaire;
            this.documentCapitalConnaisanceAdresse.push({id: beneficiaire.id, date: beneficiaire.date_document_capital_connaissance_adresse_beneficiaire});

            this.$set(this.myData.capitalFactureFraisObseque, beneficiaire.id, beneficiaire.date_document_capital_facture_acquittee_frais_obseque);
            this.documentCapitalFactureFraisObseque.push({id: beneficiaire.id, date: beneficiaire.date_document_capital_facture_acquittee_frais_obseque});

            this.$set(this.myData.capitalChampLibre1, beneficiaire.id, beneficiaire.date_document_capital_champ_libre1);
            this.documentCapitalChampLibre1.push({id: beneficiaire.id, date: beneficiaire.date_document_capital_champ_libre1});
            this.myData.libelleCapitalChampLibre1 = beneficiaire.libelle_capital_champ_libre1;

            this.$set(this.myData.capitalChampLibre2, beneficiaire.id, beneficiaire.date_document_capital_champ_libre2);
            this.documentCapitalChampLibre2.push({id: beneficiaire.id, date: beneficiaire.date_document_capital_champ_libre2});
            this.myData.libelleCapitalChampLibre2 = beneficiaire.libelle_capital_champ_libre2;
          }
        }
      },
      setDocumentsBeneficiaireRentes() {
        if (!isEmpty(this.dossier.deces_beneficiaire)) {
          this.clearDocumentsRentes();
          for (let beneficiaire of this.dossier.deces_beneficiaire) {
            // this.myData.rentesRib[beneficiaire.id] = beneficiaire.date_document_rente_rib;
            this.$set(this.myData.rentesRib, beneficiaire.id, beneficiaire.date_document_rente_rib);
            this.documentRentesRib.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_rib});

            this.myData.rentesJustificatifDomicile[beneficiaire.id] = beneficiaire.date_document_rente_justificatif_domicile;
            this.documentRentesJustificatifDomicile.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_justificatif_domicile});

            this.myData.rentesActeNaissance[beneficiaire.id] = beneficiaire.date_document_rente_extrait_acte_naissance;
            this.documentRentesActeNaissance.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_extrait_acte_naissance});

            this.myData.rentesPI[beneficiaire.id] = beneficiaire.date_document_rente_piece_identite;
            this.documentRentesPI.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_piece_identite});

            this.myData.rentesCertificatScolarite[beneficiaire.id] = beneficiaire.date_document_rente_certificat_scolarite;
            this.documentRentesCertificatScolarite.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_certificat_scolarite});

            this.myData.rentesAttestationSsEtudiant[beneficiaire.id] = beneficiaire.date_document_rente_attestation_ss_etudiant;
            this.documentRentesAttestationSsEtudiant.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_attestation_ss_etudiant});

            this.myData.rentesContratApprentissage[beneficiaire.id] = beneficiaire.date_document_rente_contrat_apprentissage;
            this.documentRentesContratApprentissage.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_contrat_apprentissage});

            this.myData.rentesJugementTutelle[beneficiaire.id] = beneficiaire.date_document_rente_jugement_tutelle;
            this.documentRentesJugementTutelle.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_jugement_tutelle});

            this.myData.rentesAttestationPoleEmploi[beneficiaire.id] = beneficiaire.date_document_rente_attestation_inscription_pole_emploi;
            this.documentRentesAttestationPoleEmploi.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_attestation_inscription_pole_emploi});

            this.myData.rentesCarteInvaliditeMdph[beneficiaire.id] = beneficiaire.date_document_rente_carte_invalidite_mdph;
            this.documentRentesCarteInvaliditeMdph.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_carte_invalidite_mdph});

            this.myData.rentesAttestationRenteSubstitutive[beneficiaire.id] = beneficiaire.date_document_rente_attestation_rente_substitutive_conjoint;
            this.documentRentesAttestationRenteSubstitutive.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_attestation_rente_substitutive_conjoint});

            this.$set(this.myData.rentesChampLibre1, beneficiaire.id, beneficiaire.date_document_rente_champ_libre1);
            this.documentRentesChampLibre1.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_champ_libre1});
            this.myData.libelleRenteChampLibre1 = beneficiaire.libelle_rente_champ_libre1;

            this.$set(this.myData.rentesChampLibre2, beneficiaire.id, beneficiaire.date_document_rente_champ_libre2);
            this.documentRentesChampLibre2.push({id: beneficiaire.id, date: beneficiaire.date_document_rente_champ_libre2});
            this.myData.libelleRenteChampLibre2 = beneficiaire.libelle_rente_champ_libre2;
          }
        }
      },
      clearDocumentsCapital() {
        this.documentCapitalRib = [];
        this.documentCapitalJustificatifDomicile = [];
        this.documentCapitalJugementTutelle = [];
        this.documentCapitalConnaisanceAdresse = [];
        this.documentCapitalPI = [];
        this.documentCapitalFactureFraisObseque = [];
        this.documentCapitalChampLibre1 = [];
        this.documentCapitalChampLibre2 = [];
      },
      clearDocumentsRentes() {
        this.documentRentesRib = [];
        this.documentRentesJustificatifDomicile = [];
        this.documentRentesActeNaissance = [];
        this.documentRentesPI = [];
        this.documentRentesCertificatScolarite = [];
        this.documentRentesAttestationSsEtudiant = [];
        this.documentRentesContratApprentissage = [];
        this.documentRentesJugementTutelle = [];
        this.documentRentesAttestationPoleEmploi = [];
        this.documentRentesCarteInvaliditeMdph = [];
        this.documentRentesAttestationRenteSubstitutive = [];
        this.documentRentesChampLibre1 = [];
        this.documentRentesChampLibre2 = [];
      },
      getCapitalDecesLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.capital)) {
          for (let capital of this.capitalOptions) {
            if (beneficiaire.capital.indexOf(capital.code) > -1) {
              libelle = libelle + capital.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getRentesLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.rentes)) {
          for (let rente of this.rentesOptions) {
            if (beneficiaire.rentes.indexOf(rente.code) > -1) {
              libelle = libelle + rente.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      getAllocationsLibelle(beneficiaire) {
        let libelle = '';
        if (!isEmpty(beneficiaire.allocations)) {
          for (let allocation of this.allocationsOptions) {
            if (beneficiaire.allocations.indexOf(allocation.code) > -1) {
              libelle = libelle + allocation.name + ' <b>|</b> ';
            }
          }
        }
        return libelle.replace(/ <b>\|<\/b> $/, '');
      },
      save() {
        this.$parent.$parent.$parent.save('save');
      },
    }
  }
</script>
<style type="text/css">
  #stacked-checkbox-group .custom-checkbox {
    display: block !important;
  }

  .blue-date {
    color: #20a8d8;
    font-weight: bold;
  }
</style>
